import React, { Component } from 'react';
import Login from './login';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import * as AccontAction from '../accountActions';

class LoginForm extends Component {

	handleSubmit(values) {
		const { accountActions, history } = this.props;
		accountActions.onLoginUser({ email: values.email, password: values.password, navigation: history });
	  }

	onCreateAccount() {
		const { history } = this.props;
		history.push('/register');
	}

	onForgotPassword(){
		const { history } = this.props;
		history.push('/forgetPassword');
	}

	render() {
		const { isLoading } = this.props;
		return (<Login 
			onSubmit={this.onSubmit}
			onCreateAccount={()=> this.onCreateAccount()}
			onForgotPassword={()=> this.onForgotPassword()}
			isLoading={isLoading}
			handleSubmitBtn={values => this.handleSubmit(values)}
        />
		);
	}
}


const mapStateToProps = ({ userAccount }) => {
	const { isLoading } = userAccount;
	return {
	  isLoading,
	};
  };
  


const mapDispatchToProps = (dispatch) => {
	return {
		accountActions: bindActionCreators(AccontAction, dispatch),
	};
};
export default connect(mapStateToProps, mapDispatchToProps)(withRouter(LoginForm));